import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/badges', parameters);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Badge.js